<span class="d-inline-flex align-items-center gap-1">
  <i
    class="fa"
    [class.fa-plus-circle]="isAdd"
    [class.fa-minus-circle]="!isAdd"
    [class.text-success]="isAdd"
    [class.text-danger]="!isAdd"
  ></i>
  {{ label }}
</span>
